import React from "react";

import { apiPath } from "@/helpers/apiPath";
import { defaultPageItems } from "@/helpers/apiPathHelpers";
import { SearchInterface } from "@/helpers/pageHelpers/Common/interface";
import ContentLoader from "@/components/ContentLoader";
import ArticleTile from "@/components/FeedTiles/ArticleTile";
import { ArticleTileProps } from "@/helpers/pageHelpers/Article/interface";
import Button from "@/components/Button";
import { usePagination } from "@/helpers/usePagination";
import EmptyState from "@/components/EmptyState";

import styles from "../Search.module.scss";

export const SearchArticles: React.FC<SearchInterface> = ({ phrase }) => {
  const {
    elements,
    isLoadingInitialData,
    isLoadingMore,
    isEmpty,
    isReachingEnd,
    loadMore,
  } = usePagination([], defaultPageItems.SEARCH_DEFAULT, (index) =>
    apiPath.SEARCH_ARTICLES({ page: index + 1, searchQuery: phrase })
  );

  return (
    <>
      {elements.map((element, index) => {
        return (
          <ArticleTile
            key={index}
            variant="small"
            {...(element as ArticleTileProps)}
          />
        );
      })}

      {isLoadingMore && <ContentLoader height={150} amount={3} />}

      {isEmpty && (
        <EmptyState
          className={styles.emptyState}
          subheading="Spróbuj zmienić wpisaną frazę lub sprawdź popularne treści."
        />
      )}

      {elements?.length > 0 && !isReachingEnd && !isLoadingInitialData && (
        <Button
          variant="secondary"
          onClick={loadMore}
          className={styles.loadMore}
        >
          Wczytaj więcej
        </Button>
      )}
    </>
  );
};

export default SearchArticles;
